import { Chip, type ChipColor } from "@legal-500/legal500-design-system";
import styles from "./SentimentChip.module.css";

const SENTIMENT_CHIP: Record<string, { label: string; color: ChipColor }> = {
  positive: { label: "Positive", color: "success" },
  negative: { label: "Negative", color: "error" },
  neutral: { label: "Neutral", color: "default" },
};

function getSentimentChip(sentiment: string | null): { label: string; color: ChipColor } | null {
  if (!sentiment) return null;
  return SENTIMENT_CHIP[sentiment.toLowerCase()] ?? null;
}

type SentimentChipProps = {
  sentiment: string | null;
};

export function SentimentChip({ sentiment }: SentimentChipProps) {
  const chip = getSentimentChip(sentiment);

  if (!chip) return <>—</>;

  return (
    <Chip
      size="small"
      variant="filled"
      color={chip.color}
      className={chip.color === "default" ? styles.sentimentChipNeutral : undefined}
    >
      {chip.label}
    </Chip>
  );
}
